(() => {
    const commentRatedHandler = (commentId, rate) => {
        alert(`Comment #${commentId} rated: ${rate}`);
    }
    document.addEventListener('DOMContentLoaded', () => {
        // pass callback as last argument to enable rating
        CommentsStarsPlugin('.comment-stars', 'star', 'star-full', 'star-empty', /*commentRatedHandler*/);
        TabsPlugin('.tabs-wrapper', (tabIdx) => {
            const el = document.querySelector('.tabs-wrapper');
            const tabsContentEls = el.querySelectorAll('[data-tab-content]');
            tabsContentEls.forEach((el) => {
                if (el.dataset.tabContent === tabIdx) {
                    el.style.display = 'block';
                } else {
                    el.style.display = 'none';
                }
            });
        });
        AccordionPlugin('.faq-questions');
        let swiper;
        const initSlider = () => {
            const vw =  Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
            const isMobile = vw < 1024;
            const enableTouch = 'ontouchstart' in document;
            if (isMobile) {
                new Swiper('.map-mobile-slider .swiper', {
                    direction: 'horizontal',
                    loop: true,
                    pagination: {
                        el: '.swiper-pagination',
                    },
                    spaceBetween: 10,
                    cssMode: enableTouch,
                });
            }
        }

        window.onresize = (r) => {
            swiper && swiper.destroy();
            initSlider();
        }

        initSlider();
    });
})();
